// import { nycZipCodes } from "../../react/utils/nycZipCodes"

// Get the true document height and set it as a variable
export const docHeight = () => {
  const documentHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty("--doc-height", `${window.innerHeight}px`)
  }
  window.addEventListener("resize", documentHeight)
  documentHeight()
}

// Throttle function to limit how often saveTimeUpdate runs
export function throttle(fn, wait) {
  let lastTime = 0
  return function (...args) {
    const now = Date.now()
    if (now - lastTime >= wait) {
      lastTime = now
      fn.apply(this, args)
    }
  }
}
